export default __webpack_public_path__ + "static/media/IMG11.0af806ec.png";